exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SortOptionItem__sortIcon___yOtIY {\n  margin-right: 8px;\n  width: 14px;\n  height: 14px; }\n\n.SortOptionItem__sortOption___3wQAH {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 0; }\n  .SortOptionItem__sortOption___3wQAH .SortOptionItem__imgTextContainer___1wZeJ {\n    display: flex;\n    align-items: center; }\n    .SortOptionItem__sortOption___3wQAH .SortOptionItem__imgTextContainer___1wZeJ .SortOptionItem__text___1EOrp {\n      color: #000000;\n      font-size: 15px;\n      font-weight: 400;\n      line-height: 23px; }\n    .SortOptionItem__sortOption___3wQAH .SortOptionItem__imgTextContainer___1wZeJ .SortOptionItem__sortIcon___yOtIY {\n      vertical-align: inherit;\n      width: 21px;\n      height: 20px; }\n", ""]);

// exports
exports.locals = {
	"sortIcon": "SortOptionItem__sortIcon___yOtIY",
	"sortOption": "SortOptionItem__sortOption___3wQAH",
	"imgTextContainer": "SortOptionItem__imgTextContainer___1wZeJ",
	"text": "SortOptionItem__text___1EOrp"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/SortOption/SortOptionMobile/SortOptionItem/styles/SortOptionItem.scss
// module id = 4289
// module chunks = 6